/**
 * TOPページ ヒーローイメージ スクロールボタン
 */
import SmoothScroll from 'smooth-scroll';

const attachScrollEvent = () => {
    const scrollBtn = document.querySelector('.s-hero-scroll');
    if (!scrollBtn) return false;

    scrollBtn.addEventListener('click', (event) => {
        if (event.preventDefault) event.preventDefault();
        const scrollAnim = new SmoothScroll();
        // ヒーローイメージ高さ取得
        const hero = document.querySelector('.s-hero');
        const heroHeight = hero.clientHeight;
        scrollAnim.animateScroll(heroHeight);
        return false;
    });

    return scrollBtn;
};

module.exports = (() => {
    attachScrollEvent();
})();
    


// WEBPACK FOOTER //
// ./js/modules/heroScroll.js